import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'environments/environment';

export interface CreditSafeSearchPersonResult {
  first_name?: string,
  last_name?: string,
  address?: string,
  zip?: string,
  city?: string,
  social_security_number?: string,
}

export interface CreditSafeSearchPersonResponse {
  status: string,
  result: CreditSafeSearchPersonResult
}

export interface Signatory {
  first_name: string,
  last_name: string,
  social_security_number: string,
}

export interface CreditSafeSearchOrganizationResult {
  company_name?: string,
  orgno?: string,
  address?: string,
  zip?: string,
  city?: string,
  company_email?: string[],
  company_telephone?: string[],
  signatories?: Signatory[],
}

export interface CreditSafeSearchOrganizationResponse {
  status: string,
  result: CreditSafeSearchOrganizationResult
}

export interface CreditSafeRatingStatus {
  status: string,
  status_txt: string,
}

export interface CreditSafeRatingResponse {
  status: string,
  result?: string,
  status_list: CreditSafeRatingStatus,
  error_list: any[],
}

export interface SkoogsConfig {
  uuid: string,
  type: string,
  reject_message: string,
}

@Injectable({
  providedIn: 'root'
})

export class CreditSafeService {

  //@todo: These UUIDs are used just a temporary solution for Skoogs bränsle, please remove it later.
  private readonly skoogsConfigs: SkoogsConfig[] = [
    {
      uuid: '4d0fdaf6-828d-4857-b100-28f57a483cea', type: 'ORG_T6',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: '99024b0e-af24-4809-82fb-9a0904c6ec3f', type: 'ORG_T5',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: 'aa9545cb-732a-4cd2-a83a-f640af03e550', type: 'ORG_T5',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    { 
      uuid: '3b2f0cd1-54cc-431f-8f2f-c001c4d97cc5', type: 'ORG_T4',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: 'ca07cf10-b2ef-4944-a56f-b435d54006de', type: 'ORG_T3',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: '7b0d08d3-acc0-4496-9eca-521b3b9ca5bd', type: 'ORG_T2',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning för den kreditnivå du valt. Pröva gärna söka på en lägre kredit. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: '47d490d2-4dd0-4fd0-9db3-571d4c9a5a5e', type: 'ORG_T1',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: 'b989492d-7bea-475a-85c8-684491b7a930', type: 'ORG_T1', // Returning customer
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: 'fd4df10a-8cf3-4980-ab20-6627d795e5ce', type: 'PRIVATE',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
    {
      uuid: '507df5b9-70af-4fb0-822a-069f89267ccd', type: 'PRIVATE',
      reject_message: "Tack för att du vill bli kund hos oss på Skoogs Bränsle AB. Din ansökan om tankkort har tyvärr inte gått igenom vår automatiska kreditprövning. Om du har frågor rörande detta är du välkommen att kontakta oss på bransle@skoogs.se"
    },
  ];

  private readonly apiUrl = `creditsafe`;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  isSkoogsUniqueId(uniqueId: string): boolean {
    return this.skoogsConfigs.some(config => config.uuid === uniqueId);
  }

  getSkoogsConfigurationType(uniqueId: string): string | null {
    const config = this.skoogsConfigs.find(config => config.uuid === uniqueId);
    return config ? config.type : null;
  }

  getSkoogsRejectMessage(type: string): string | null {
    const config = this.skoogsConfigs.find(config => config.type === type);
    return config ? config.reject_message : null;
  }

  searchPerson(socialSecurityNumber: string): Observable<CreditSafeSearchPersonResponse> {
    this.setLoading(true);

    const body = {
      'block_key': 'BLOCK_2',
      'social_security_number': socialSecurityNumber,
    };

    return this.http.post<CreditSafeSearchPersonResponse>(`${this.apiUrl}/person-details`, body).pipe(
        tap(() => this.setLoading(false)),
        catchError((error) => {
          this.setLoading(false);
          return this.handleError(error);
        })
    );
  }

  searchOrganization(organizationNumber: string): Observable<CreditSafeSearchOrganizationResponse> {
    this.setLoading(true);

    const body = {
      'block_key': 'BLOCK_1',
      'organization_number': organizationNumber,
    };

    return this.http.post<CreditSafeSearchOrganizationResponse>(`${this.apiUrl}/organization-details`, body).pipe(
        tap(() => this.setLoading(false)),
        catchError((error) => {
          this.setLoading(false);
          return this.handleError(error);
        })
    );
  }

  checkPersonCreditRating(templateKey: string,
                          personalNumber: string,
                          email?: string,
                          phone?: string): Observable<CreditSafeRatingResponse> {
    this.setLoading(true);

    const body = {
      template_key: templateKey,
      social_security_number: personalNumber,
      agrees_to_creditcheck: true,
      ...(email && { email }),
      ...(phone && { phone })
    };

    return this.http.post<CreditSafeRatingResponse>(`${this.apiUrl}/check-person`, body).pipe(
        tap(() => this.setLoading(false)),
        catchError((error) => {
          this.setLoading(false);
          return this.handleError(error);
        })
    );
  }

  checkOrganizationCreditRating(templateKey: string,
                                organizationNumber: string,
                                email?: string,
                                phone?: string): Observable<CreditSafeRatingResponse> {
    this.setLoading(true);

    const body = {
      'template_key': templateKey,
      'organization_number': organizationNumber,
      'agrees_to_creditcheck': true,
      ...(email && { email }),
      ...(phone && { phone })
    }

    return this.http.post<CreditSafeRatingResponse>(`${this.apiUrl}/check-organization`, body).pipe(
        tap(() => this.setLoading(false)),
        catchError((error) => {
          this.setLoading(false);
          return this.handleError(error);
        })
    );
  }

  private handleError(error: any) {
    const standardError = {
      status: error.status || 422, // Default to 422 if status is missing
      message: typeof error === 'string' ? error : (error.message || error.error || 'Unknown error'),
      originalError: error
    };

    return throwError(() => standardError);
  }

  private setLoading(loading: boolean): void {
    this.loadingSubject.next(loading);
  }
}
